/* ---- Opt in to reveal animations -------------------------------------------------
   Adding this class is what switches the hidden start state on. It is only added when the
   browser can actually deliver the reveal, so a browser that cannot still gets a full page. */
(function () {
  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  document.documentElement.classList.add("js-reveal");
})();

/* ---- Mobile sheet ------------------------------------------------------------------ */
(function () {
  var btn = document.getElementById("burger"), sheet = document.getElementById("sheet");
  if (!btn || !sheet) return;
  function set(on) {
    if (on) sheet.setAttribute("data-open", ""); else sheet.removeAttribute("data-open");
    // aria-expanded is the only state written; CSS derives which glyph shows from it.
    btn.setAttribute("aria-expanded", on ? "true" : "false");
    document.documentElement.style.overflow = on ? "hidden" : "";
  }
  btn.addEventListener("click", function () { set(!sheet.hasAttribute("data-open")); });
  sheet.addEventListener("click", function (e) { if (e.target.tagName === "A") set(false); });
  window.addEventListener("keydown", function (e) { if (e.key === "Escape") set(false); });
  // Crossing the 900px breakpoint hides the burger, so the sheet must not be left open.
  window.matchMedia("(min-width: 901px)").addEventListener("change", function (m) { if (m.matches) set(false); });
})();

/* ---- Scroll reveal ----------------------------------------------------------------
   IntersectionObserver, not a scroll listener: no work on frames where nothing has
   entered the viewport. Each element is unobserved once revealed.                    */
(function () {
  var items = document.querySelectorAll("[data-reveal]");
  if (!items.length) return;
  if (!("IntersectionObserver" in window) ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    items.forEach(function (el) { el.classList.add("is-in"); });
    return;
  }
  function reveal(el, stagger) {
    if (el.classList.contains("is-in")) return;
    var delay = 0;
    if (stagger) {
      var sibs = Array.prototype.slice.call(el.parentNode.children)
                   .filter(function (n) { return n.hasAttribute && n.hasAttribute("data-reveal"); });
      var i = sibs.indexOf(el);
      if (i > 0) delay = Math.min(i, 6) * 0.07;
    }
    el.style.transitionDelay = delay + "s";
    el.classList.add("is-in");
    io.unobserve(el);
  }

  /* Anything already at or above the bottom of the viewport is revealed, whether or not the
     observer ever sampled it. This is the part that was missing: an element that goes from
     below the viewport to above it in ONE jump is never reported as intersecting, so with
     threshold-based reveal alone it stayed hidden forever. That is not a rare case here, it is
     what every anchor jump does, and it was leaving the whole checkout form invisible. */
  function sweep() {
    document.querySelectorAll("[data-reveal]:not(.is-in)").forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) reveal(el, false);
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) reveal(e.target, true); });
    sweep();                      // catch anything the jump skipped over
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0 });   // threshold 0: any pixel counts, which
  items.forEach(function (el) { io.observe(el); });      // is reliable for tall sections too

  /* Safety net, and it is not optional. Every section on this page starts at opacity 0 and is
     revealed by the observer, so anything that stops the observer delivering renders the page
     BLANK. That has happened once already. So: shortly after load, check whether the observer
     has revealed anything at all. If it has not, it is not working in this browser and the whole
     page is shown at once. A page with no scroll animation is fine; an empty page is not. */
  /* Two guarantees, both on plain timers measured from script execution. The previous version
     hung these off window.load, which does not fire until every subresource has settled: on a
     slow CDN that left the page BLANK for the whole wait, because the content is hidden until
     something reveals it. Nothing here depends on load, on the observer, or on a transition
     completing. */

  // 1. At 700ms, reveal anything at or near the viewport regardless of the observer.
  setTimeout(function () {
    document.querySelectorAll("[data-reveal]:not(.is-in)").forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 1.3) {
        el.style.transitionDelay = "0s";
        el.classList.add("is-in");
      }
    });
  }, 700);

  /* 2. Did anything actually become VISIBLE? This checks rendered opacity, not whether the class
        was added. Those are different things, and the difference is what kept biting: the class
        gets added fine, but if the opacity transition never advances (a throttled or non-painting
        tab leaves it parked at currentTime 0) the element stays invisible while every
        class-based check reports success. Measuring opacity is the only honest test. If nothing
        reached full opacity, drop the opt-in class so the hidden start state disappears outright
        and the content shows with no transition to wait on. Checked twice, in case the first
        check lands mid-transition. */
  function anyActuallyVisible() {
    var seen = document.querySelectorAll("[data-reveal].is-in");
    for (var i = 0; i < seen.length; i++) {
      if (parseFloat(getComputedStyle(seen[i]).opacity) > 0.9) return true;
    }
    return false;
  }
  function bailOutIfInvisible() {
    if (anyActuallyVisible()) return;
    document.documentElement.classList.remove("js-reveal");
    /* Removing the rule is not enough on its own. Any element that already picked up a
       transition is still holding opacity 0 at that transition's start value, so the transition
       has to be cancelled and the end state written directly. */
    document.querySelectorAll("[data-reveal]").forEach(function (el) {
      el.style.transition = "none";
      el.style.opacity = "1";
      el.style.transform = "none";
    });
  }
  setTimeout(bailOutIfInvisible, 1800);
  setTimeout(bailOutIfInvisible, 4000);

})();

/* ---- Hover to spin the product -------------------------------------------------------
   Pointer over the shot plays the rotation; pointer out pauses it AND seeks back to frame 0,
   so the product always comes to rest in the same pose rather than wherever it happened to
   stop. The file is not fetched until the first hover (preload="none"), and the poster is the
   first frame, so nothing moves and nothing downloads for a visitor who never hovers.
   Touch has no hover, so there a tap toggles it instead. */
(function () {
  var shots = [].slice.call(document.querySelectorAll(".product__shot"));
  if (!shots.length) return;
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  shots.forEach(function (shot) {
    var v = shot.querySelector(".product__spin");
    if (!v || reduced) return;
    var wanted = false;   // is the pointer still on the plate
    var dead   = false;   // the file cannot be played here; stop trying

    /* The still is only surrendered on `playing`, which is the first moment the video is
       genuinely running with a frame decoded. Anything earlier and the plate goes blank while
       the network works. `wanted` is rechecked because the pointer can leave during the fetch,
       and a video that starts playing after that must not flip the still off. */
    v.addEventListener("playing", function () {
      if (wanted) shot.setAttribute("data-spun", "");
    });
    /* A missing or undecodable file is permanent, not transient. Latch it off rather than
       re-requesting a 404 on every hover for the rest of the session. The still never moved,
       so there is nothing to restore: the plate just stops offering the spin. */
    v.addEventListener("error", function () {
      dead = true;
      shot.removeAttribute("data-spinning");
      shot.removeAttribute("data-spun");
    });

    function start() {
      if (dead) return;
      wanted = true;
      shot.setAttribute("data-spinning", "");
      v.loop = true;
      /* No explicit v.load() here, and that is the fix for "the first hover never spins".
         load() restarts resource selection and ABORTS the play() issued on the next line, so
         the first hover always rejected with AbortError and the rotation only ever worked from
         the second hover onward. play() triggers the fetch by itself under preload="none", so
         load() was never needed — it was purely destructive.
         A rejected play() is no longer treated as failure either: `playing` and `error` are the
         honest signals, and this promise is neither. */
      v.play().catch(function () {});
    }
    function stop() {
      wanted = false;
      shot.removeAttribute("data-spinning");
      shot.removeAttribute("data-spun");
      v.pause();
      /* Back to the first frame. Seeking on a video that has not loaded metadata throws the
         value away, so wait for metadata in that case rather than silently leaving it parked
         mid-rotation. */
      if (v.readyState >= 1) { try { v.currentTime = 0; } catch (e) {} }
      else v.addEventListener("loadedmetadata", function once() {
        try { v.currentTime = 0; } catch (e) {}
        v.removeEventListener("loadedmetadata", once);
      });
    }

    // pointerenter/leave rather than mouseover/out: no spurious firing when the pointer
    // crosses the spec pills stacked on top of the plate.
    shot.addEventListener("pointerenter", function (e) { if (e.pointerType !== "touch") start(); });
    shot.addEventListener("pointerleave", function (e) { if (e.pointerType !== "touch") stop(); });
    // a pointer that leaves the window entirely never fires pointerleave on the element
    window.addEventListener("blur", stop);

    shot.addEventListener("click", function (e) {
      if (e.pointerType === "mouse") return;      // desktop already has hover
      if (shot.hasAttribute("data-spinning")) stop(); else start();
    });
  });
})();

/* ---- Customer reels ----------------------------------------------------------------
   The mp4 src is attached on first play, so four 5-to-11MB files never touch the network for
   someone who only scrolls past. One reel plays at a time. Starts muted because a browser will
   refuse an unmuted programmatic play anyway; the sound control appears once it is running.  */
(function () {
  var reels = [].slice.call(document.querySelectorAll(".reel"));
  if (!reels.length) return;

  function stop(tile) {
    var v = tile.querySelector("video");
    v.pause();
    tile.removeAttribute("data-playing");
  }

  reels.forEach(function (tile) {
    var v = tile.querySelector("video");
    var sound = tile.querySelector(".reel__sound");
    var iMuted = tile.querySelector(".i-muted"), iLoud = tile.querySelector(".i-loud");

    function play() {
      if (!v.src) v.src = tile.dataset.src;      // first press pays for the download, nobody else
      reels.forEach(function (other) { if (other !== tile) stop(other); });
      v.play().then(function () {
        tile.setAttribute("data-playing", "");
        tile.setAttribute("aria-label", "Pause customer video");
      }).catch(function () { /* user can press again */ });
    }

    tile.addEventListener("click", function (e) {
      // the sound pill lives inside the button, so its clicks must not toggle playback
      if (e.target.closest(".reel__sound")) return;
      if (tile.hasAttribute("data-playing")) { stop(tile); tile.setAttribute("aria-label", "Play customer video"); }
      else play();
    });

    function toggleSound() {
      v.muted = !v.muted;
      iMuted.hidden = !v.muted; iLoud.hidden = v.muted;
      sound.setAttribute("aria-label", v.muted ? "Unmute" : "Mute");
    }
    sound.addEventListener("click", function (e) { e.stopPropagation(); toggleSound(); });
    sound.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); e.stopPropagation(); toggleSound(); }
    });

    v.addEventListener("ended", function () { stop(tile); tile.setAttribute("aria-label", "Play customer video"); });
  });

  // A reel scrolled out of view should not keep playing audio at someone.
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting && en.target.hasAttribute("data-playing")) stop(en.target);
      });
    }, { threshold: 0.25 });
    reels.forEach(function (t) { io.observe(t); });
  }
})();

/* ---- Hero ignition ------------------------------------------------------------------
   Lights the masked headline one frame after paint. Not tied to load or to an observer: the
   hero is on screen by definition, so waiting on either only risks an empty hero. If this
   never runs, `html.js-reveal` is absent or the fallback strips it and the lines show. */
(function () {
  var hero = document.querySelector(".hero");
  if (!hero) return;
  requestAnimationFrame(function () {
    requestAnimationFrame(function () { hero.classList.add("is-lit"); });
  });
  // belt and braces: if something stalls the frame loop, light it anyway
  setTimeout(function () { hero.classList.add("is-lit"); }, 600);
})();

/* ---- Split every [data-split] heading into masked words --------------------------------
   Runs BEFORE the reveal observer has fired anything, and only when `js-reveal` is on, which is
   the same gate the rest of the motion uses: no IntersectionObserver or reduced motion means the
   headings are never touched and stay plain text.
   The emphasis span (.it) is masked WHOLE rather than split. Its foil is a gradient clipped to
   the glyphs, and chopping that element into per-word boxes puts a separate transformed layer
   over each fragment, which breaks the clip in Safari and turns the line into flat blocks.
   One mask around the whole italic keeps the metal intact and still gives the line its own
   beat. */
(function () {
  if (!document.documentElement.classList.contains("js-reveal")) return;
  var heads = document.querySelectorAll("[data-split]");
  if (!heads.length) return;

  function mask(node) {
    var w = document.createElement("span"); w.className = "w";
    var inner = document.createElement("span");
    inner.appendChild(node);
    w.appendChild(inner);
    return w;
  }

  heads.forEach(function (h) {
    var frag = document.createDocumentFragment();
    // snapshot first: appending to the fragment removes each node from the heading as we go
    [].slice.call(h.childNodes).forEach(function (node) {
      if (node.nodeType === 3) {
        node.nodeValue.split(/(\s+)/).forEach(function (chunk) {
          if (!chunk) return;
          if (/^\s+$/.test(chunk)) { frag.appendChild(document.createTextNode(" ")); return; }
          frag.appendChild(mask(document.createTextNode(chunk)));
        });
      } else if (node.nodeName === "BR") {
        frag.appendChild(node);
      } else {
        frag.appendChild(mask(node));
      }
    });
    h.textContent = "";
    h.appendChild(frag);

    // Stagger by word. Capped so a long heading does not take a second and a half to land.
    var words = h.querySelectorAll(".w > span");
    for (var i = 0; i < words.length; i++) {
      words[i].style.transitionDelay = Math.min(i * 55, 480) + "ms";
    }
  });
})();

/* ---- Scroll progress ------------------------------------------------------------------
   Reads window.scrollY, which stays correct under Lenis because Lenis 1.x drives the real
   window scroll rather than transforming a wrapper. rAF-coalesced, so a burst of scroll events
   still writes the transform once per frame. */
(function () {
  var bar = document.getElementById("progress");
  if (!bar) return;
  var raf = null;
  function paint() {
    raf = null;
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var p = max > 0 ? Math.min(1, Math.max(0, window.scrollY / max)) : 0;
    bar.style.transform = "scaleX(" + p.toFixed(4) + ")";
  }
  function queue() { if (!raf) raf = requestAnimationFrame(paint); }
  window.addEventListener("scroll", queue, { passive: true });
  window.addEventListener("resize", queue);
  paint();
})();

/* ---- Cursor spotlight -----------------------------------------------------------------
   Writes two custom properties on one fixed element. Nothing re-renders: the browser only
   re-rasterises that single gradient layer. Mouse only, and skipped entirely under reduced
   motion or on a coarse pointer, where there is no cursor to follow. */
(function () {
  var spot = document.getElementById("spot");
  if (!spot) return;
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var x = 0, y = 0, raf = null;
  window.addEventListener("pointermove", function (e) {
    if (e.pointerType && e.pointerType !== "mouse") return;
    x = e.clientX; y = e.clientY;
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      spot.style.setProperty("--cx", x + "px");
      spot.style.setProperty("--cy", y + "px");
    });
  }, { passive: true });
})();

/* ---- Product plate tilt and glare ------------------------------------------------------
   Four custom properties per plate, written on a rAF-coalesced pointermove. The CSS owns the
   actual transform and the gradient position, so this never touches layout and never reads
   geometry more than once a frame. Pointer-out resets to the neutral values and the CSS
   transition springs it back. */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  document.querySelectorAll(".product__shot").forEach(function (shot) {
    var raf = null, last = null;
    shot.addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse") return;
      last = e;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var r = shot.getBoundingClientRect();
        if (!r.width || !r.height) return;
        var px = (last.clientX - r.left) / r.width;
        var py = (last.clientY - r.top) / r.height;
        shot.style.setProperty("--ry", ((px - 0.5) * 9).toFixed(2) + "deg");
        shot.style.setProperty("--rx", ((0.5 - py) * 7).toFixed(2) + "deg");
        shot.style.setProperty("--mx", (px * 100).toFixed(1) + "%");
        shot.style.setProperty("--my", (py * 100).toFixed(1) + "%");
        shot.style.setProperty("--lift", "1");
      });
    });
    function rest() {
      shot.style.setProperty("--rx", "0deg");
      shot.style.setProperty("--ry", "0deg");
      shot.style.setProperty("--lift", "0");
    }
    shot.addEventListener("pointerleave", rest);
    window.addEventListener("blur", rest);
  });
})();

/* ---- Gold dust over the hero -----------------------------------------------------------
   Slow motes rising through the light shaft. Hero only, and stopped the moment the hero leaves
   the viewport or the tab is hidden: a particle field that keeps running for the whole page is
   the single most reliable way to make a page like this stutter on a mid-range phone.
   Everything here is additive. No canvas, no context, or reduced motion just means no dust. */
(function () {
  var c = document.getElementById("dust");
  if (!c || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var ctx = c.getContext && c.getContext("2d");
  if (!ctx) return;

  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var w = 0, h = 0, parts = [], raf = null, visible = true, onScreen = true;

  function size() {
    var r = c.getBoundingClientRect();
    w = r.width; h = r.height;
    if (!w || !h) return false;
    c.width = Math.round(w * dpr); c.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    return true;
  }

  function seed() {
    // Count scales with width so a phone is not drawing a desktop's worth of particles.
    var n = Math.round(Math.min(72, Math.max(22, w / 17)));
    parts = [];
    for (var i = 0; i < n; i++) {
      parts.push({
        x: Math.random() * w,
        y: Math.random() * h,
        r: 0.5 + Math.random() * 1.8,
        vy: -(0.07 + Math.random() * 0.26),
        vx: (Math.random() - 0.5) * 0.14,
        a: 0.14 + Math.random() * 0.46,
        p: Math.random() * Math.PI * 2,
        s: 0.005 + Math.random() * 0.013
      });
    }
  }

  function frame() {
    raf = null;
    ctx.clearRect(0, 0, w, h);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      p.p += p.s;
      p.y += p.vy;
      p.x += p.vx + Math.sin(p.p) * 0.2;
      if (p.y < -8) { p.y = h + 8; p.x = Math.random() * w; }
      if (p.x < -8) p.x = w + 8; else if (p.x > w + 8) p.x = -8;
      // Two passes per mote: a wide faint halo and a tight bright core. Cheaper than a
      // per-particle radial gradient and it is what makes them read as light, not as dots.
      var a = p.a * (0.5 + 0.5 * Math.sin(p.p));
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r * 3.2, 0, 6.2832);
      ctx.fillStyle = "rgba(255,206,96," + (a * 0.16).toFixed(3) + ")";
      ctx.fill();
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, 6.2832);
      ctx.fillStyle = "rgba(255,232,168," + a.toFixed(3) + ")";
      ctx.fill();
    }
    if (visible && onScreen) raf = requestAnimationFrame(frame);
  }

  function run() {
    if (raf || !visible || !onScreen || !parts.length) return;
    raf = requestAnimationFrame(frame);
  }
  function halt() {
    if (raf) { cancelAnimationFrame(raf); raf = null; }
  }

  if (!size()) return;
  seed();
  run();

  var rt = null;
  window.addEventListener("resize", function () {
    clearTimeout(rt);
    rt = setTimeout(function () { if (size()) { seed(); run(); } }, 180);
  });

  document.addEventListener("visibilitychange", function () {
    visible = !document.hidden;
    if (visible) run(); else halt();
  });

  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting;
      if (onScreen) run(); else halt();
    }, { threshold: 0 }).observe(c);
  }
})();

/* ---- Magnetic primary CTA -------------------------------------------------------------
   The gold button leans a few pixels toward the cursor and springs back. Written straight to
   style on pointermove rather than through state, so it never re-renders anything and stays
   smooth. Mouse only, and off entirely under reduced motion. */
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  document.querySelectorAll(".btn--gold").forEach(function (btn) {
    var raf = null;
    btn.addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse") return;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        btn.style.transform = "translate(" + (dx * 9).toFixed(2) + "px," + (dy * 6).toFixed(2) + "px)";
      });
    });
    btn.addEventListener("pointerleave", function () {
      btn.style.transition = "transform .45s cubic-bezier(.16,1,.3,1)";
      btn.style.transform = "";
      setTimeout(function () { btn.style.transition = ""; }, 460);
    });
  });
})();

/* ---- Header scroll state -----------------------------------------------------------
   Watches whether the hero still reaches under the header band. An IntersectionObserver with a
   negative top rootMargin gives that as one boolean with no per-frame work, and it keeps working
   under Lenis, which a scroll listener reading window.scrollY would not.
   NOTE: this only firms the capsule up. It is NOT what makes the header legible; the capsule is
   dark and its text white in every state, so a failure here cannot hide the navigation. */
(function () {
  var nav = document.getElementById("nav");
  var hero = document.querySelector(".hero");
  if (!nav || !hero || !("IntersectionObserver" in window)) return;
  new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) nav.removeAttribute("data-scrolled");
      else nav.setAttribute("data-scrolled", "");
    });
  }, { rootMargin: "-84px 0px 0px 0px", threshold: 0 }).observe(hero);
})();


window.addEventListener("load", function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  var lenis = null;

  /* ---- Lenis: weighted scrolling.
     Motivated: the page is a stack of full-width bands, and inertial scrolling makes the
     band-to-band transition read as one continuous surface instead of a jump per notch.
     Touch is left on the native scroller, where the OS already does this better. */
  if (typeof Lenis === "function") {
    lenis = new Lenis({ duration: 1.05, smoothWheel: true, syncTouch: false });
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    // Anchors have to go through Lenis, or the browser's own jump fights the inertia.
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var id = a.getAttribute("href");
        if (id.length < 2) return;
        var target = document.querySelector(id);
        if (!target) return;
        e.preventDefault();
        lenis.scrollTo(target, { offset: -80 });
        // the jump skips the intermediate scroll positions, so reveal what we landed on
        setTimeout(function () {
          document.querySelectorAll("[data-reveal]:not(.is-in)").forEach(function (el) {
            if (el.getBoundingClientRect().top < window.innerHeight * 1.1) {
              el.style.transitionDelay = "0s"; el.classList.add("is-in");
            }
          });
        }, 700);
      });
    });
  }

  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  // Hand ScrollTrigger Lenis's scroll position, otherwise triggers fire against the native
  // offset and every scrubbed animation lags behind what is on screen.
  if (lenis) {
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);
  }

  /* ---- Hero parallax.
     Motivated: depth. The jars stay planted while the headline and CTAs travel over them,
     which is what makes the hero feel like a photograph rather than a flat banner. */
  var heroImg = document.querySelector(".hero__bg img");
  if (heroImg) {
    gsap.set(heroImg, { scale: 1.12, transformOrigin: "50% 40%" });
    gsap.to(heroImg, {
      yPercent: 9, ease: "none",
      scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true }
    });
  }

  /* ---- Count-up on the two COA figures.
     Motivated: hierarchy. These two numbers are the whole argument of that section, and
     landing on them draws the eye to the evidence rather than to the document thumbnail. */
  document.querySelectorAll("[data-count]").forEach(function (el) {
    var target = parseFloat(el.dataset.count);
    var obj = { v: 0 };
    gsap.to(obj, {
      v: target, duration: 1.3, ease: "power2.out",
      scrollTrigger: { trigger: el, start: "top 88%", once: true },
      onUpdate: function () { el.textContent = obj.v.toFixed(2); }
    });
  });

  /* ---- Purification photograph.
     Motivated: depth again, and it is the one element in that band that can carry it without
     touching the copy. Scrubbed, so it tracks the scroll rather than playing on a timer. */
  var purifyShot = document.querySelector(".purify__shot img");
  if (purifyShot) {
    gsap.fromTo(purifyShot, { scale: 1.14 }, {
      scale: 1, ease: "none",
      scrollTrigger: { trigger: ".purify", start: "top bottom", end: "center center", scrub: true }
    });
  }

  /* ---- The purification thread draws with the scroll.
     Motivated: the section's claim is that purification is a SEQUENCE, so the graphic is drawn
     as a sequence rather than presented finished.
     Safe by construction: --draw defaults to 1 in the CSS, so the resting state with no GSAP,
     no ScrollTrigger or a trigger that never fires is a fully drawn gold rule, which is a
     finished design. Nothing here can hide content — the thread IS the content it animates. */
  var thread = document.getElementById("railThread");
  if (thread) {
    gsap.fromTo(thread, { "--draw": 0 }, {
      "--draw": 1, ease: "none",
      scrollTrigger: { trigger: ".rail", start: "top 82%", end: "bottom 72%", scrub: 0.6 }
    });
  }

  /* NOTE: the rail steps and the bento cells are deliberately NOT animated here.
     `gsap.from` sets opacity 0 on the spot and only restores it when its ScrollTrigger fires, so
     a trigger that never fires (a short viewport, a refresh at the wrong moment, a measurement
     taken before images settle) leaves real content permanently invisible. Those elements already
     stagger in through the IntersectionObserver reveal above, which cannot fail that way, and
     doubling the two up made them fight over opacity. */

  // Bands and images settle as they load, so let ScrollTrigger re-measure once everything has.
  ScrollTrigger.refresh();
  window.addEventListener("load", function () { ScrollTrigger.refresh(); });
});


/* ---- Shopify cart hand-off ------------------------------------------------------------
   This replaces the custom checkout that used to post to /api/rv/order. The pack radios carry
   real Shopify variant ids, so pressing the button clears the cart, adds the chosen variant and
   hands the customer to Shopify's own checkout, which owns payment, tax and shipping.

   The cart is CLEARED first on purpose. This is a paid-traffic landing page: whatever a visitor
   left in their cart on a previous visit must not silently ride along into an order they think
   is one jar.

   The form still has a real action="/cart/add" and method="post", so with no JS, a failed fetch
   or an ad-blocker in the way, the browser's own submit does the same job. Nothing here is
   load-bearing for being able to buy. */
(function () {
  var form = document.getElementById("rvBuy");
  if (!form) return;

  var money = function (n) { return "$" + n.toFixed(2); };
  var subEl = document.getElementById("rvSub");
  var totEl = document.getElementById("rvTotal");

  function selected() { return form.querySelector('input[name="id"]:checked'); }

  function paint() {
    var r = selected();
    if (!r) return;
    var p = parseFloat(r.getAttribute("data-price") || "0");
    if (subEl) subEl.textContent = money(p);
    if (totEl) totEl.textContent = money(p);
  }
  form.addEventListener("change", function (e) {
    if (e.target && e.target.name === "id") paint();
  });
  paint();

  // Deep link: /pages/landing_page?variant=123 preselects that pack, so an ad can point at one.
  try {
    var want = new URLSearchParams(location.search).get("variant");
    if (want) {
      var hit = form.querySelector('input[name="id"][value="' + want.replace(/[^0-9]/g, "") + '"]');
      if (hit) { hit.checked = true; paint(); }
    }
  } catch (e) {}

  var busy = false;
  form.addEventListener("submit", function (e) {
    if (busy) { e.preventDefault(); return; }
    var r = selected();
    if (!r) return;                                  // nothing chosen: let the browser complain
    if (!window.fetch) return;                       // no fetch: plain form post handles it

    e.preventDefault();
    busy = true;
    var btn = document.getElementById("rvGo");
    if (btn) btn.setAttribute("data-busy", "");

    var json = { "Content-Type": "application/json" };
    fetch("/cart/clear.js", { method: "POST", headers: json, credentials: "same-origin" })
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST", headers: json, credentials: "same-origin",
          body: JSON.stringify({ items: [{ id: Number(r.value), quantity: 1 }] })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error("add failed");
        window.location.href = "/checkout";
      })
      .catch(function () {
        // Hand it back to the browser rather than stranding the customer on a dead button.
        busy = false;
        if (btn) btn.removeAttribute("data-busy");
        form.submit();
      });
  });
})();
